import React, { useEffect, useState } from "react";
import { collectionlist } from "../../../services/admin";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";

export default function Allcollection() {
  const [filterProduct, setFilterProduct] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [urllink, setUrllink] = useState("");
  useEffect(() => {
    const path = location.pathname.split("/")[2];
    setUrllink(path);
    if(path === "allcollection"){
      collectionlist(localStorage.getItem("branch")).then((res) => {
        if (res.status === true) {
          setFilterProduct(res.data.normal);
        }
      });
    }else{
      collectionlist(localStorage.getItem("branch")).then((res) => {
      if (res.status === true) {
        setFilterProduct(res.data.advanced);
      }
    });
    }
    
  }, [location.pathname]);

  const columnDefs = [

    {
      headerName: "Collection Date",
      field: "collection_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-YYYY");
        }
      }
    },
    {
      headerName: "Staff",
      field: "loan_staff_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Group Name",
      field: "loan_group_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },


    {
      headerName: "Collection Amount",
      field: "total_collection",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Action",
      field: "collection_date",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              className="btn-sm btn-warning me-2"
              onClick={() => navigate(`/collection/datewisecollection/${params.value}`)}
            >
              <i className="fa fa-list"></i>
            </a>
            {localStorage.getItem("Role") === "1" && (
              <a
                className="btn-sm btn-success"
                onClick={() => navigate(`/collection/editcollection/${params.value}/${params.data.loan_group}`)}
              >
                <i className="fa fa-edit"></i>
              </a>
            )}
          </div>
        );
      },
    },
  ];


  const columnPDefs = [

    {
      headerName: "Collection Date",
      field: "collection_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-YYYY");
        }
      }
    },
    {
      headerName: "Staff",
      field: "loan_staff_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Group Name",
      field: "loan_group_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },


    {
      headerName: "Collection Amount",
      field: "total_collection",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
   
  ];
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">{urllink === "allcollection" ? "All Collection" : "Pre Loan Collection"}</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>{urllink === "allcollection" ? "Collection" : "Pre Loan Collection"}</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {urllink === "allcollection" ? "All Collection" : "Pre Loan Collection"}
          </li>
        </ol>

      </div>


      <div className="content-body">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                  All Collection
                </h2>
              </div>
              <div className="card-body">
                <div className="ag-theme-alpine ag-style mt-2">
                  <AgGridReact
                    columnDefs={urllink === "allcollection" ? columnDefs : columnPDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
